
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Tdce", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3678304a7c8f79fa$export$2e2bcd8739ae039);

var $6WXNs = parcelRequire("6WXNs");

var $8QebJ = parcelRequire("8QebJ");
async function $3678304a7c8f79fa$export$2e2bcd8739ae039(_, { tenantContext: tenantContext }) {
    if (tenantContext.appEditions.serviceDesk === (0, $6WXNs.PREMIUM_EDITION) || !tenantContext.atlassianAccountId) return {
        announcementDismissState: {
            shouldShow: false
        }
    };
    const announcementDismissState = await (0, $8QebJ.getAnnouncementDismissState)({
        accountId: tenantContext.atlassianAccountId
    });
    return {
        announcementDismissState: announcementDismissState
    };
}

});
parcelRegister("8QebJ", function(module, exports) {

$parcel$export(module.exports, "getAnnouncementDismissState", () => $5544b961f8dbe49a$export$753ac10f2fe7c188);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $abI4C = parcelRequire("abI4C");
async function $5544b961f8dbe49a$export$753ac10f2fe7c188({ accountId: accountId }) {
    try {
        const response = await (0, $48bs8.getUserProperty)(accountId, (0, $abI4C.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY));
        if (!response || typeof response !== 'object') {
            (0, $guiFP.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                    teamName: '50cent'
                },
                error: new (0, $7byHA.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $abI4C.DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE;
        }
        if (!Object.keys((0, $abI4C.DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(response, key))) // If missing properties occur we are making sure they are filled in from the defaults
        return {
            ...(0, $abI4C.DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE),
            ...response
        };
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error instanceof (0, $7byHA.default) && error.statusCode === 404) return 0, $abI4C.DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE;
        (0, $guiFP.default)({
            meta: {
                id: 'getAnnouncementDismissState',
                packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                teamName: '50cent'
            },
            error: error
        });
    }
}

});



//# sourceMappingURL=async-resource-jsm-repackaging-announcement.cda0ed83.js.map
